// extracted by mini-css-extract-plugin
export default {"container":"style_container__xJtg3","backgroundImg":"style_backgroundImg__-x6pI","titleBox":"style_titleBox__dHRSn"};